import { generateMeasuresFromDimensions } from './generate-measures.js';
const aggregatableDimensions = {
    'meeting_members.employer': {
        aggregations: ['countDistinct'],
        label: 'Employer',
        type: 'string',
    },
    'meeting_members.ethnicity': {
        aggregations: ['countDistinct'],
        label: 'Ethnicity',
        type: 'string',
    },
};
export const meetingMembersCube = {
    category: 'Members',
    description: 'Meeting member contact information including email, phone, and website.',
    label: 'Meeting Members',
    measures: {
        'meeting_members.count': { label: 'Count', type: 'number' },
        ...generateMeasuresFromDimensions(aggregatableDimensions),
    },
    dimensions: {
        ...aggregatableDimensions,
        'meeting_members.avatar_url': {
            label: "Member's Avatar",
            renderAs: 'image',
            type: 'string',
        },
        'meeting_members.email': { label: 'Email', type: 'string' },
        'meeting_members.first_name': { label: 'First Name', type: 'string' },
        'meeting_members.has_user_account': { label: 'Has Linked User Account', type: 'boolean' },
        'meeting_members.is_serving_active_term': {
            label: 'Currently Serving Active Term',
            type: 'boolean',
        },
        'meeting_members.last_name': { label: 'Last Name', type: 'string' },
        'meeting_members.notes': { label: 'Notes', narrative: true, type: 'string' },
        'meeting_members.occupation': { label: 'Occupation', type: 'string' },
        'meeting_members.website': { label: 'Website', type: 'string' },
        'phones.number': { label: 'Phone Number', type: 'string' },
    },
    timeDimensions: {
        'meeting_members.created_at': { label: 'Created At', type: 'date' },
        'meeting_members.updated_at': { label: 'Updated At', type: 'date' },
    },
};
